export default __webpack_public_path__ + "static/media/pic3.e9ef8f31.jpg";